
export const apiAddress =  process.env.REACT_APP_API_URL;

export const msTeamsProvisionerApp = {
    id: 'd24383d9-d81d-4e02-a55c-94b36ccaef84',
    manageCenterTabId: 'manageCenter-tab',
    createSiteTabId: 'manageCenter-tab',
    demandRequestTabId: 'demandRequest-tab',
    deliveryCenterTabId: 'deliveryCenter-tab',
    teamsLiveCollabTabId: 'teamsLiveCollab-tab'
};

export const msTeamsSpApp = {
    id: '7b49c510-80cb-11ea-a297-a37306eccdef',
    trainingsTabId: 'trainings-tab'
};

export const limitVersioning = {
    versionsLimit: 100,
    versionsDays: 180
};



// WEBPACK FOOTER //
// ./src/GlobalConst/globalConst.js